import { trackYandexGoal } from '@actions/utils';
import UiButton from '@ui/Button';
import { getTimeZone } from '@utils/date';
import React, { useState } from 'react';
import request from 'superagent';

const DolyameButton = props => {
  const { plan, phone, isValid, email, onClickPay } = props;
  const [loading, setLoading] = useState(false);

  const processPayment = () => {
    onClickPay();

    if (loading || !isValid) return;

    trackYandexGoal(`buy-${plan}`);

    setLoading(true);

    request
      .post('/payment/init')
      .send({
        tel: phone,
        plan,
        email,
        method: 'dolyame',
        timezone: getTimeZone(),
      })
      .end((err, res) => {
        setLoading(false);
        if (!err && res.body.url) window.location = res.body.url;
      });
  };

  return (
    <UiButton
      onClick={processPayment}
      color="black"
      size="big"
      style={{ maxWidth: 300 }}
      disabled={loading}
    >
      <img
        src={require('../../../../../assets/images/dolyame.svg')}
        alt="btc"
      />
    </UiButton>
  );
};

export default DolyameButton;
